import React from 'react';
import { Navbar } from '../components/layout/Navbar';
import { Footer } from '../components/layout/Footer';
import { HeroSection } from './crisis/HeroSection';
import { MainContentSection } from './crisis/MainContentSection';
export function CrisisManagementPage() {
  return <div className="min-h-screen flex flex-col bg-brand-black" data-id="element-548">
      <Navbar data-id="element-549" />
      <main className="flex-grow pt-[7.25rem]" data-id="element-550">
        <HeroSection data-id="element-551" />
        <MainContentSection data-id="element-552" />
      </main>
      <Footer data-id="element-553" />
    </div>;
}